import {
  agencyParameterTemplateDetailed,
  agencyParameterTemplateEditable,
  agencyParameterTemplateOverview,
  baseAgencyParameterTemplate
} from '@app/pcs/models/agency-parameter-template';
import { gql } from 'apollo-angular';

export const trainParametersTemplatesQuery = gql`
  query trainParametersTemplates ($searchCriteria: AgencyParameterTemplateSearchInput!) {
    trainParametersTemplates (searchCriteria: $searchCriteria) {
      ...baseAgencyParameterTemplate
    }
  }
  ${baseAgencyParameterTemplate}
`;

export const trainParametersTemplatesOverviewQuery = gql`
  query trainParametersTemplatesOverview ($searchCriteria: AgencyParameterTemplateSearchInput!) {
    trainParametersTemplates (searchCriteria: $searchCriteria) {
      ...agencyParameterTemplateOverview
    }
  }
  ${agencyParameterTemplateOverview}
`;

export const trainParametersTemplateQuery = gql`
  query trainParametersTemplate ($templateId: Long!) {
    trainParametersTemplate (templateId: $templateId) {
      ...agencyParameterTemplateDetailed
    }
  }
  ${agencyParameterTemplateDetailed}
`;

export const emptyTrainParametersTemplateQuery = gql`
  query emptyTrainParametersTemplate ($context: AgencyParameterTemplateContextInput) {
    emptyTrainParametersTemplate (context: $context) {
      ...agencyParameterTemplateDetailed
    }
  }
  ${agencyParameterTemplateDetailed}
`;

export const trainParametersTemplateEditableQuery = gql`
  query trainParametersTemplateEditable ($templateId: Long!) {
    trainParametersTemplate (templateId: $templateId) {
      ...agencyParameterTemplateEditable
    }
  }
  ${agencyParameterTemplateEditable}
`;

export const validateTrainParametersTemplateName = gql`
  query ValidateTrainParametersTemplateName ($template: AgencyParameterTemplateInput!) {
    validateTrainParametersTemplateName (template: $template)
  }
`;

export const updateTemplateParameterDependenciesQuery = gql`
  query updateTemplateParameterDependencies ($template: AgencyParameterTemplateInput!,
    $trainParameters: TrainParametersInput!) {
    updateTemplateParameterDependencies (template: $template, trainParameters: $trainParameters) {
      ...agencyParameterTemplateDetailed
    }
  }
  ${agencyParameterTemplateDetailed}
`;
